










































// eslint-disable-next-line object-curly-newline
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

import { getErrorResponse, ERROR_403 } from '@/helpers/getErrorResponse'
import BLayoutEmpty from '@/components/layouts/BLayoutEmpty.vue'


@Component({
  name: 'view-error',
  components: {
    BLayoutEmpty,
  },
})
export default class ViewErrors extends Vue {
  @Prop({ type: [String, Number], default: '500' })
  public code!: string;

  @Prop(String)
  public label!: string;

  @Prop(String)
  public message!: string;

  @Prop(String)
  public fromRoute!: string;

  public get settings(): { label?: string; message?: string; code: number | string } {
    return this.label
      ? { label: this.label, message: this.message, code: this.code }
      : getErrorResponse(this.code)
  }

  public get is403Error(): boolean {
    return this.settings.code === ERROR_403
  }

  @Watch('fromRoute', { immediate: true })
  public onChangeFromRoute(): void {
    if (!this.fromRoute) return
    window.history.replaceState({}, '', this.fromRoute)
  }
}
